import { render, staticRenderFns } from "./ComercioCityUser.vue?vue&type=template&id=4e146917&"
import script from "./ComercioCityUser.vue?vue&type=script&lang=js&"
export * from "./ComercioCityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports